import type { CityConfig } from "../city-template/types";

export const livingstonConfig: CityConfig = {
  city: "Livingston",
  state: "Montana",
  stateAbbr: "MT",
  slug: "livingston",
  route: "/livingston",
  title: "Emergency Passport Livingston, MT — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Livingston, MT — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Livingston, Paradise Valley, Gardiner, and Park County travelers. No Denver trip needed.",
  h1: "Emergency & Expedited Passport Services in Livingston, MT",
  heroSubtitle: "Yellowstone gateway trip to Canada? Paradise Valley ranch guests heading abroad? Livingston artist residency or gallery show overseas? We help Livingston residents — from fly fishing guides to Yellowstone seasonal workers to Paradise Valley ranchers — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20panoramic%20view%20of%20Livingston%20Montana%20with%20the%20Yellowstone%20River%20flowing%20through%20the%20foreground%20and%20the%20snowcapped%20Absaroka%20Mountains%20in%20the%20background%20at%20golden%20hour%2C%20historic%20downtown%20main%20street%20with%20vintage%20western%20architecture%2C%20dramatic%20big%20sky%20with%20warm%20amber%20light%2C%20editorial%20travel%20photography%20style%20with%20crisp%20detail%20and%20rich%20natural%20colors&width=1800&height=700&seq=livingston-hero-2026&orientation=landscape",
  heroImageAlt: "Livingston Montana with Yellowstone River and Absaroka Mountains at golden hour",
  geoPosition: "45.6610;-110.5610",
  geoPlacename: "Livingston, Montana",
  lastModified: "2026-06-15",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "Cherry Creek III, 3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
    distance: "Nearest regional passport agency — located approximately 590 miles from Livingston; not practical for most Park County residents",
  },
  nearbyCitiesZips: [
    { name: "Livingston", zips: "59047" },
    { name: "Gardiner", zips: "59030" },
    { name: "Emigrant", zips: "59027" },
    { name: "Pray", zips: "59065" },
    { name: "Clyde Park", zips: "59018" },
    { name: "Wilsall", zips: "59086" },
    { name: "Big Timber", zips: "59011" },
    { name: "Bozeman", zips: "59715" },
  ],
  benefits: [
    { icon: "ri-global-line", title: "Yellowstone Cross-Border Passport Expertise", desc: "Yellowstone National Park visitors and seasonal workers often cross between Gardiner, MT and Canadian Rockies destinations. We help Park County residents and Yellowstone-bound travelers get passports for cross-border adventures." },
    { icon: "ri-flight-takeoff-line", title: "BZN Bozeman Yellowstone International Airport", desc: "Just 35 miles west of Livingston, BZN connects through Salt Lake City, Denver, Seattle, Minneapolis, and Chicago for international departures. We coordinate timelines around your BZN connection." },
    { icon: "ri-building-2-line", title: "No Denver Trip Needed", desc: "Denver Passport Agency is 590 miles away — completely impractical for Livingston residents. Our registered courier service handles everything remotely." },
    { icon: "ri-home-2-line", title: "Paradise Valley Ranchers + Seasonal Workers", desc: "Yellowstone seasonal employees, Paradise Valley ranch staff, and artist-in-residence participants need fast passport turnaround when contracts and opportunities surface with short notice. We understand the Livingston rhythm." },
  ],
  internalLinks: [
    { name: "Expedited passport in Bozeman, MT", route: "/bozeman" },
    { name: "Fast passport services in Billings, MT", route: "/billings" },
    { name: "Quick passport services in Missoula, MT", route: "/missoula" },
    { name: "Urgent passport services in Jackson, WY", route: "/jackson-wy" },
    { name: "Montana passport services overview", route: "/montana" },
  ],
  fpcOfficeAddress: "3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
  fpcOfficeNote: "Fast Passport Center serves Livingston via secure registered courier with direct access to the Denver Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without driving 9+ hours to Colorado. Livingston residents can ship from any UPS Store, FedEx Office, or post office location across Park County.",
  fpcOfficeDistance: "Serving Livingston, Gardiner, Emigrant, Pray, Clyde Park, Wilsall, Big Timber, and all Park County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Livingston and Paradise Valley. From the historic downtown district along the Yellowstone River to the north entrance corridor to Yellowstone at Gardiner, from the ranches of Paradise Valley to the artist studios and fly shops of downtown Livingston — we serve all of Park County. Our courier service eliminates the need to drive 590 miles to Denver for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Livingston and all Park County communities including Gardiner, Emigrant, Pray, and Clyde Park. We also serve Yellowstone seasonal employees, Paradise Valley ranchers, and the vibrant Livingston arts community.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Livingston as simple as possible — with the reliability Paradise Valley ranchers, Yellowstone seasonal workers, and Livingston's artist community need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Livingston travelers start online and ship documents overnight — no office visit required.",
  mistakesIntro: "Livingston travelers encounter unique passport issues — from Yellowstone seasonal employment documentation to Paradise Valley address verification to international art exhibition timeline pressure. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Paradise Valley travelers — from Gardiner seasonal guides to Livingston fly fishing outfitters to Park County ranchers — trust us when their international departure is days away and Denver is simply not an option.",
  faqIntro: "Have questions about expedited passports in Livingston, MT? Here are the most common ones we hear from Paradise Valley travelers.",
  statePageRoute: "/states/montana",
  statePageName: "Montana",
  servicesIntro: "Whether you need a renewal before a Canadian Rockies trip from Yellowstone, an emergency passport for a last-minute BZN connecting flight, or a first-time passport for a Paradise Valley family vacation abroad — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dojmt.gov/driving/",
  dmvLabel: "Montana Motor Vehicle Division — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins", "Life-or-death emergencies only", "Denver agency is 590 miles from Livingston", "Completely impractical for Park County residents"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "No Denver trip needed — we handle everything remotely", "Ideal for upcoming international travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service through post office", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with government shutdowns", "In-person clerk appointment required in Livingston or Bozeman", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "BZN flight connecting to international departure in 2 days? Yellowstone cross-border emergency? Our emergency courier service submits directly via reserved slots — as fast as 24 hours for Livingston travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Livingston residents renew fast — no agency visit required for most renewals. Perfect for Paradise Valley ranchers, fly fishing guides, and Livingston artists traveling abroad.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Park County residents through every step with clear instructions for the nearest acceptance facility.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms like DS-64. We guide you through everything needed — so your Yellowstone seasonal work or BZN international connection is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions so your Paradise Valley family trip abroad stays on track.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or legal name change — we assist with corrected passports so travel documents match reservations. Common for Livingston area residents after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Livingston artists with gallery shows abroad, fly fishing outfitters guiding internationally, and Paradise Valley business owners.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Park County travelers through the process so your international plans stay on schedule.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Ideal for Livingston residents crossing into Alberta from the Yellowstone region.",
      bullets: ["Wallet-size convenience", "Land and sea crossings to Canada", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Livingston MT", description: "Urgent passport processing for Livingston Montana travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Livingston MT", description: "Fast passport renewal for Livingston Montana residents with a previously-issued passport." },
    { name: "First-Time Passport Livingston MT", description: "New passport application services for Livingston Montana residents applying for their first passport." },
    { name: "Child Passport Livingston MT", description: "Minor passport services for Livingston Montana families with children under 16." },
    { name: "Name Change Passport Livingston MT", description: "Passport name correction after marriage, divorce, or legal name changes for Livingston residents." },
    { name: "Second Passport Livingston MT", description: "Second passport services for Livingston frequent travelers and creative professionals." },
  ],
  testimonials: [
    {
      name: "Rebecca M.",
      location: "Livingston",
      rating: 5,
      text: "I had an artist residency in Ireland and realized my passport was expiring just three weeks before my flight. Fast Passport Center got it renewed and back to me in 5 days. Without them I would have missed the entire opportunity — driving to Denver was out of the question.",
      service: "Passport Renewal",
    },
    {
      name: "Tom H.",
      location: "Gardiner",
      rating: 5,
      text: "Working as a Yellowstone seasonal guide and got a last-minute opportunity in Banff for the summer. Needed a passport renewal fast and they delivered in 4 days. Amazing service for rural Montana — no Denver trip needed.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "The Callahan Family",
      location: "Paradise Valley",
      rating: 5,
      text: "Our ranch hosts international guests year-round and we needed kids' passports updated for a family trip to New Zealand. They walked us through everything, reviewed our documents, and got all four passports back in time. Incredible peace of mind.",
      service: "Child Passport — Family",
    },
    {
      name: "Dan W.",
      location: "Livingston",
      rating: 5,
      text: "Fly fishing outfitter heading to Patagonia for the season — needed my passport renewed on short notice. Fast Passport Center handled it remotely. Living in rural Park County, having a courier service that actually works without the Denver drive is a game changer.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "livingston-1",
      name: "Livingston Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "121 N 2nd St",
      city: "Livingston",
      state: "MT",
      zip: "59047",
      phone: "(406) 222-3709",
      hours: "Mon–Fri 9:00 AM – 3:30 PM (appointment required)",
      distance: "Downtown Livingston",
      website: "https://tools.usps.com/find-location.htm?location=1372818",
      websiteLabel: "USPS Location",
      notes: "Primary acceptance facility for Park County. Limited appointment availability during summer tourist season — schedule at least a week in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "livingston-2",
      name: "Bozeman Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "32 E Babcock St",
      city: "Bozeman",
      state: "MT",
      zip: "59715",
      phone: "(406) 586-1502",
      hours: "Mon–Fri 9:00 AM – 4:30 PM (appointment required)",
      distance: "Bozeman — about 35 miles west of Livingston",
      website: "https://tools.usps.com/find-location.htm?location=1365418",
      websiteLabel: "USPS Location",
      notes: "Larger facility with regular passport acceptance hours. About 35 minutes from Livingston — useful when the Livingston office is fully booked.",
      icon: "ri-mail-line",
    },
    {
      id: "livingston-3",
      name: "Park County Clerk of District Court",
      type: "County Clerk Passport Acceptance",
      address: "414 E Callender St",
      city: "Livingston",
      state: "MT",
      zip: "59047",
      phone: "(406) 222-4125",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      distance: "Downtown Livingston — Park County Courthouse",
      website: "https://parkcounty.org/",
      websiteLabel: "Park County Website",
      notes: "Alternative to post office acceptance facilities. Appointment recommended. Does not offer photo services — bring your own passport photo.",
      icon: "ri-government-line",
    },
    {
      id: "livingston-4",
      name: "Gardiner Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "701 Scott St W",
      city: "Gardiner",
      state: "MT",
      zip: "59030",
      phone: "(406) 848-7579",
      hours: "Mon–Fri 8:30 AM – 4:00 PM (appointment required)",
      distance: "Gardiner — Yellowstone north entrance, about 53 miles south of Livingston",
      website: "https://tools.usps.com/find-location.htm?location=1367180",
      websiteLabel: "USPS Location",
      notes: "Nearest acceptance facility to Yellowstone National Park's north entrance. Limited hours during off-season — call to confirm passport acceptance availability.",
      icon: "ri-mail-line",
    },
    {
      id: "livingston-5",
      name: "Big Timber Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "224 McLeod St",
      city: "Big Timber",
      state: "MT",
      zip: "59011",
      phone: "(406) 932-5242",
      hours: "Mon–Fri 8:30 AM – 4:30 PM (appointment required)",
      distance: "Big Timber — about 34 miles east of Livingston",
      website: "https://tools.usps.com/find-location.htm?location=1364861",
      websiteLabel: "USPS Location",
      notes: "Serves eastern Park County and Sweet Grass County residents. Call ahead to confirm passport acceptance availability.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — Denver Passport Agency, 590 miles and 9+ hour drive from Livingston", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to Aurora, CO near Denver; completely impractical for Park County residents", fpc: "Most Livingston travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — must prove travel date and emergency", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay, even more problematic from rural Montana", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Practicality for Livingston", agency: "590-mile drive to Denver one way — completely impractical for most Park County residents", fpc: "Entirely remote — forms online, ship from Livingston, passport arrives at your door" },
    { feature: "Who Can Use It", agency: "Strict eligibility — life-or-death emergency only with proof of travel", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but factoring in travel to Denver, time off work, and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Paradise Valley Context", agency: "No Livingston-specific guidance — no Yellowstone, BZN, or rural Park County expertise", fpc: "Full Park County knowledge — Yellowstone, BZN airport, seasonal employment patterns" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Yellowstone Seasonal Employment Passport Gaps",
      description: "Yellowstone concession workers often arrive from across the country and internationally. Seasonal staff with expiring passports who are offered Canada-side roles need fast renewals — many don't realize how quickly Denver appointments fill in summer or how far the agency actually is from Park County.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for BZN Connection Timing",
      description: "BZN connects through Denver, Salt Lake City, Seattle, and Minneapolis for international flights. A passport issue at the connection point delays the entire itinerary. We ensure your passport is valid before your first departure from Bozeman.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Paradise Valley Address Verification Issues",
      description: "Rural Paradise Valley addresses and ranch mailing addresses can differ from residential addresses on documentation. Mismatched addresses cause delays. We review all documentation to catch this common rural Montana issue.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations from Rural Pharmacies",
      description: "Local Montana pharmacies in smaller towns may produce photos that don't meet strict State Department standards. We catch this in review before it causes a rejection and delays your international departure.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Waiting Until Denver Is No Longer an Option",
      description: "Many Livingston travelers wait until 2 weeks before departure, then realize Denver is 590 miles away. Our courier channel is the only practical expedited option in Park County — but starting 3-4 weeks ahead is still recommended.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order from your Livingston home or Gardiner lodge." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist — whether you are a Paradise Valley rancher, Yellowstone seasonal worker, or Livingston artist heading overseas." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using overnight shipping. Most Livingston clients ship from the UPS Store on Park Street or the Livingston Post Office — no Denver trip needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "Your documents arrive at our processing center. We submit through reserved agency slots — so Park County travelers never need to drive to Denver." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Arrives at Your Door", description: "Your passport is completed within your selected timeframe and shipped directly to your Livingston, Gardiner, or Paradise Valley address. No agency visit. No Denver. Just your passport, on time." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Livingston, Montana?", a: "We offer Livingston-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. Because Livingston's nearest regional passport agency is in Denver (590 miles away), our remote courier service is the most practical fast option in Park County." },
    { q: "Do I need to visit a Livingston office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (Livingston Post Office, Park County Clerk of Court, or the Gardiner Post Office), then ship documents overnight. We handle the State Department submission and return your passport to your Park County address." },
    { q: "Where can I get a passport acceptance near Livingston?", a: "Livingston has acceptance facilities at the Post Office on 2nd Street, the Park County Clerk of District Court, and nearby USPS locations in Gardiner, Big Timber, and Bozeman. We maintain an updated list of Park County-area facilities with hours and appointment requirements." },
    { q: "I work seasonally at Yellowstone — can you help with fast passport processing?", a: "Yes. Yellowstone seasonal workers are some of our most frequent clients. When summer opportunities in Canada or winter contracts in the Southern Hemisphere come up with short notice, we process expedited passports so you don't miss the opportunity. Our remote courier service means you never need to drive to Denver." },
    { q: "What if I need a passport and Denver is too far?", a: "Denver Passport Agency is 590 miles from Livingston — a 9+ hour drive each way through Wyoming. That's why our registered courier service is the best expedited option in Park County and Paradise Valley. We handle the agency submission remotely, so you never leave Montana." },
    { q: "What is the best price for expedited passport service in Livingston?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other resellers. We offer a best price guarantee." },
    { q: "What documents do Livingston applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Park County-specific checklist." },
    { q: "Can I get a passport photo in Livingston?", a: "Yes. The Livingston Post Office offers limited on-site passport photos. CVS and other pharmacies in Bozeman (35 miles west) also provide passport photo services. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "How does rural Paradise Valley address affect passport applications?", a: "Rural route addresses and ranch mailing addresses can differ from residential addresses on documentation. We help Park County residents navigate this — providing guidance to avoid delays caused by address mismatches between your documents and application." },
    { q: "Can you help with passports for BZN Bozeman Yellowstone International Airport departures?", a: "Yes. BZN is just 35 miles from Livingston and connects through major hubs like Denver, Salt Lake City, Seattle, and Minneapolis for international flights. We help Livingston travelers time their passport processing around BZN connections, ensuring your passport is valid and ready before you leave Park County." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Livingston Residents",
    intro: "Livingston's position in Paradise Valley — at the north entrance to Yellowstone and along the I-90 corridor — creates unique passport timing challenges. Here's what Park County travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "BZN — Bozeman Yellowstone International Airport",
        subtitle: "Just 35 miles west of Livingston, the region's primary airport",
        description: "BZN serves the entire Greater Yellowstone region with connections through Denver, Salt Lake City, Seattle, Minneapolis, and Chicago O'Hare. Most Livingston international travelers connect through these hubs. The airport's seasonal schedule means summer months see a surge in passport urgencies as tourists, seasonal workers, and Yellowstone-bound visitors prepare for international connections.",
        tip: "BZN connections to international flights mean your passport needs to be valid when you check in at Bozeman, not just at your international gateway. Check your passport the moment you book any international itinerary through BZN.",
      },
      {
        icon: "ri-road-map-line",
        title: "Yellowstone to Canadian Rockies Corridor",
        subtitle: "International travel between two world-class national park regions",
        description: "Livingston sits on the natural route between Yellowstone National Park and Banff/Jasper in the Canadian Rockies. Many Park County residents, ranch guests, and seasonal workers travel between the two regions, requiring valid passports for the U.S.-Canada border crossing. The Sweetgrass/Coutts border crossing (I-15) is the most common route.",
        tip: "Even a quick trip from Yellowstone to Banff or Waterton requires a passport. Seasonal workers and guides who navigate both U.S. and Canadian parks need their passport valid throughout the season — plan renewals during shoulder seasons (April or October).",
      },
      {
        icon: "ri-home-2-line",
        title: "Seasonal Workers & Yellowstone Employment",
        subtitle: "Concession and park staff with dynamic international opportunities",
        description: "Yellowstone seasonal workers make up a significant portion of Livingston's summer population. When international seasonal opportunities arise — Canadian Rockies guiding, New Zealand winter seasons, Patagonia fishing lodges — turnaround time is often 2-4 weeks from offer to departure. These workers need reliable fast passport processing that doesn't require a Denver pilgrimage.",
        tip: "Yellowstone seasonal workers should check their passport expiration before the season starts. A passport renewed in April means no panic when a Canada or overseas opportunity surfaces in August with a tight turnaround.",
      },
      {
        icon: "ri-palette-line",
        title: "Livingston Arts & Creative Professionals",
        subtitle: "Gallery shows, residencies, and international creative opportunities",
        description: "Livingston has a vibrant arts community with painters, writers, sculptors, and musicians who regularly travel internationally for residencies, exhibitions, and performances. These opportunities often come with 4-6 weeks notice — tight timelines where passport readiness is critical and a Denver trip is a major disruption to the creative workflow.",
        tip: "Creative professionals with active international careers should consider a second passport. When your primary passport is with a foreign embassy for a visa, a second passport lets you continue traveling for other opportunities.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Livingston & the Yellowstone Gateway Corridor",
      description: "Livingston is the original gateway to Yellowstone National Park, with the historic Northern Pacific Railroad depot marking the entry point for early park visitors. Today, the Yellowstone River and Paradise Valley corridor connect Livingston to Gardiner at the park's north entrance. International visitors from Canada, Europe, and Asia pass through this corridor — and Livingston residents head the other direction to explore the Canadian Rockies and beyond.",
    },
  },
  destinations: {
    title: "Where Livingston Travelers Go — And Why Passports Get Urgent",
    intro: "Livingston's position in Paradise Valley, near Yellowstone and along the I-90 corridor, shapes its international travel patterns. Here are the most common destinations and urgency scenarios we see.",
    stats: [
      { stat: "35%", label: "of Livingston expedited requests involve Canadian Rockies cross-border travel" },
      { stat: "3–4 Weeks", label: "average lead time from trip booking to departure for Park County travelers" },
      { stat: "May–Aug", label: "peak season when Yellowstone seasonal workers arrive and summer travel kicks in" },
      { stat: "590 Miles", label: "distance to nearest passport agency in Denver — our courier service bridges this" },
    ],
    destinations: [
      { name: "Canada", context: "Banff and Jasper National Parks, Calgary Stampede, Canadian Rockies guiding, Waterton Lakes, Vancouver film industry", urgency: "Summer peak demand when seasonal workers transition between Yellowstone and Canadian Rockies roles", icon: "ri-map-pin-2-line" },
      { name: "Europe", context: "Artist residencies in Ireland and France, gallery exhibitions in London and Berlin, heritage travel to UK, Germany, Scandinavia", urgency: "Residency and exhibition acceptances with 4–6 week lead time", icon: "ri-map-pin-2-line" },
      { name: "New Zealand & Australia", context: "Fly fishing guiding in South Island, winter seasonal work during Montana's off-season, adventure travel", urgency: "Seasonal contracts with 2–4 week turnaround from offer to departure", icon: "ri-map-pin-2-line" },
      { name: "South America", context: "Patagonia fishing expeditions, Chile and Argentina adventure travel, ranch exchange programs", urgency: "Southern Hemisphere summer season (November–February) bookings", icon: "ri-map-pin-2-line" },
      { name: "Mexico & Central America", context: "Winter getaways for Park County residents, fishing expeditions to Baja, resort vacations", urgency: "Fall bookings as summer winds down and winter travel plans are made", icon: "ri-map-pin-2-line" },
      { name: "Asia", context: "Connections through Seattle and Denver, fly fishing equipment manufacturing partnerships, creative collaborations", urgency: "Trade and exhibition travel with fixed dates", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Montana Service Areas",
    crossLinksDesc: "We serve travelers across Big Sky Country with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Bozeman", route: "/bozeman" },
      { name: "Billings", route: "/billings" },
      { name: "Missoula", route: "/missoula" },
    ],
  },
  photoLocations: [
    { name: "Livingston Post Office", address: "121 N 2nd St, Livingston, MT 59047", hours: "Mon–Fri 9 AM – 3:30 PM (limited photo service)" },
    { name: "CVS Pharmacy — Bozeman", address: "115 N 19th Ave, Bozeman, MT 59718", hours: "Daily 8 AM – 9 PM (35 miles from Livingston)" },
    { name: "Walgreens — Bozeman", address: "1200 S 19th Ave, Bozeman, MT 59715", hours: "Daily 8 AM – 10 PM (35 miles from Livingston)" },
    { name: "The UPS Store — Bozeman", address: "1450 N 19th Ave, Bozeman, MT 59718", hours: "Call for hours" },
    { name: "FedEx Office — Bozeman", address: "200 S 23rd Ave, Bozeman, MT 59718", hours: "Call for hours" },
    { name: "Walmart Supercenter — Bozeman", address: "1500 N 7th Ave, Bozeman, MT 59715", hours: "Daily 6 AM – 11 PM" },
  ],
  dmvLocations: [
    {
      name: "Park County Treasurer — Motor Vehicle Division",
      address: "414 E Callender St, Livingston, MT 59047",
      hours: "Mon–Fri, 8:00 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment recommended.",
      featured: true,
    },
    {
      name: "Montana MVD — Bozeman Driver Exam Station",
      address: "3811 Valley Commons Dr, Bozeman, MT 59718",
      hours: "Tue–Fri, 7:30 AM – 5:00 PM (by appointment)",
      note: "Driver license testing and renewals. REAL ID available. About 35 miles from Livingston.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "BZN",
      name: "Bozeman Yellowstone International Airport",
      distance: "About 35 miles west of Livingston (35 minutes via I-90)",
      address: "850 Gallatin Field Rd, Belgrade, MT 59714",
      note: "Serves the Greater Yellowstone region with connections to Denver, Salt Lake City, Seattle, Minneapolis, Chicago O'Hare, and seasonal direct flights to additional hubs. The busiest airport in Montana.",
      flightUrl: "https://www.bozemanairport.com/",
      flightLabel: "Bozeman Airport Website",
      featured: true,
    },
    {
      code: "BIL",
      name: "Billings Logan International Airport",
      distance: "About 115 miles east of Livingston (1 hour 45 minutes via I-90)",
      address: "1901 Terminal Cir, Billings, MT 59105",
      note: "Larger regional airport with additional connections. Alternative for Livingston travelers needing more flight options or different airlines.",
      flightUrl: "https://www.flybillings.com/",
      flightLabel: "Billings Airport Website",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified Montana birth certificates from the Montana Department of Public Health and Human Services. Online, mail, or in-person options available.",
      url: "https://dphhs.mt.gov/vitalrecords/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through Montana DPHHS Vital Records. Required for estate and legal matters in Park County.",
      url: "https://dphhs.mt.gov/vitalrecords/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Park County Clerk of District Court. Certified copies available for name changes and passport applications.",
      url: "https://parkcounty.org/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Park County District Court. Required for name change passport corrections.",
      url: "https://parkcounty.org/",
    },
  ],
};